import 'chart.js/auto';
import { Line } from 'react-chartjs-2';
import { useGetMarkerHistoryChartOptions } from './hooks/useGetMarkerHistoryChartOptions';
import useInLightMode from 'hooks/useInLightMode';
import {
  darkModeMarkerColors,
  lightModeMarkerColors,
} from 'features/spectrumChart/utils/colors';
import { MarkerHistoryForm, MarkerHistoryResults } from './types';
import { UseFormWatch } from 'react-hook-form';

interface Props {
  markerData: MarkerHistoryResults;
  watch: UseFormWatch<MarkerHistoryForm>;
}

const MarkerHistoryChart = ({ markerData, watch }: Props) => {
  const inLightMode = useInLightMode();
  const chartOptions = useGetMarkerHistoryChartOptions('dBm', 'Marker History');
  const data = {
    labels: markerData.timeStamps,
    datasets: [
      {
        id: 1,
        label: 'Marker 1',
        data: markerData.marker1History,
        borderJoinStyle: 'round' as 'round' | 'miter' | 'bevel',
        spanGaps: false,
        backgroundColor: inLightMode
          ? lightModeMarkerColors[0]
          : darkModeMarkerColors[0],
        borderColor: inLightMode
          ? lightModeMarkerColors[0]
          : darkModeMarkerColors[0],
      },
      {
        id: 2,
        label: 'Marker 2',
        data: markerData.marker2History,
        borderJoinStyle: 'round' as 'round' | 'miter' | 'bevel',
        spanGaps: false,
        backgroundColor: inLightMode
          ? lightModeMarkerColors[1]
          : darkModeMarkerColors[1],
        borderColor: inLightMode
          ? lightModeMarkerColors[1]
          : darkModeMarkerColors[1],
      },
      {
        id: 3,
        label: 'Marker 3',
        data: markerData.marker3History,
        borderJoinStyle: 'round' as 'round' | 'miter' | 'bevel',
        spanGaps: false,
        backgroundColor: inLightMode
          ? lightModeMarkerColors[2]
          : darkModeMarkerColors[2],
        borderColor: inLightMode
          ? lightModeMarkerColors[2]
          : darkModeMarkerColors[2],
      },
      {
        id: 4,
        label: 'Marker 4',
        data: markerData.marker4History,
        borderJoinStyle: 'round' as 'round' | 'miter' | 'bevel',
        spanGaps: false,
        backgroundColor: inLightMode
          ? lightModeMarkerColors[3]
          : darkModeMarkerColors[3],
        borderColor: inLightMode
          ? lightModeMarkerColors[3]
          : darkModeMarkerColors[3],
      },
      {
        id: 5,
        label: 'M2 - M1',
        data: markerData.m2M1Delta,
        borderJoinStyle: 'round' as 'round' | 'miter' | 'bevel',
        spanGaps: false,
        backgroundColor: 'orange',
        borderColor: 'orange',
      },
      {
        id: 6,
        label: 'M3 - M1',
        data: markerData.m3M1Delta,
        borderJoinStyle: 'round' as 'round' | 'miter' | 'bevel',
        spanGaps: false,
        backgroundColor: 'green',
        borderColor: 'green',
      },
      {
        id: 7,
        label: 'M4 - M1',
        data: markerData.m4M1Delta,
        borderJoinStyle: 'round' as 'round' | 'miter' | 'bevel',
        spanGaps: false,
        backgroundColor: 'purple',
        borderColor: 'purple',
      },
    ],
  };

  let amountSpliced = 0;

  if (watch('hideMarker1')) {
    data.datasets.splice(0, 1);
    amountSpliced++;
  }

  if (watch('hideMarker2')) {
    data.datasets.splice(1 - amountSpliced, 1);
    amountSpliced++;
  }

  if (watch('hideMarker3')) {
    data.datasets.splice(2 - amountSpliced, 1);
    amountSpliced++;
  }

  if (watch('hideMarker4')) {
    data.datasets.splice(3 - amountSpliced, 1);
    amountSpliced++;
  }

  if (watch('hideM2M1')) {
    data.datasets.splice(4 - amountSpliced, 1);
    amountSpliced++;
  }

  if (watch('hideM3M1')) {
    data.datasets.splice(5 - amountSpliced, 1);
    amountSpliced++;
  }

  if (watch('hideM4M1')) {
    data.datasets.splice(6 - amountSpliced, 1);
    amountSpliced++;
  }

  if (markerData.timeStamps.length === 0) {
    return <></>;
  }

  return (
    <>
      <Line
        data={data}
        // @ts-ignore
        options={chartOptions}
      />
    </>
  );
};

export default MarkerHistoryChart;
